<template>
  <section ref="seccion" id="resultados" class="text-white [--color-focus-ring:#FFFFFF] ">
    <div class="grid lg:grid-cols-[minmax(0,59fr)_minmax(0,41fr)] lg:items-stretch overflow-hidden relative">
      <img
      :src="patron"
      alt=""
      aria-hidden="true"
      class="gob-patron-decorativo w-180 -left-12 opacity-70"
    />
      <div class="cerebro-panel-texto flex bg-surface-deep">
        <div class="cerebro-panel-contenido flex w-full flex-col justify-center py-14 md:py-18 lg:py-22">
          <h2 class="text-gob-6 leading-[1.05] font-black tracking-gob-tightest text-balance">
            Sin tareas duplicadas.<br>Sin datos fagmentados.
          </h2>
          <h2 class="text-gob-6 leading-[1.05] font-semibold tracking-gob-tightest text-balance mt-2"><span class="bg-electric rounded-xl px-1.5">Gob 24/7</span> es el cerebro digital que <span class="bg-electric rounded-xl px-1.5">conecta personas</span> con servicios.</h2>
          <dl class="mt-10 flex flex-col gap-4 md:mt-14 mr-8">
            <div v-for="metrica in metricas" :key="metrica.etiqueta" class="flex items-center gap-4 border-b border-white/15 py-4">
              <dd class="shrink-0 text-gob-dato leading-none font-black tracking-gob-tightest tabular-nums">
                {{ metrica.valor }}
              </dd>
              <dt class="leading-relaxed text-white/85">{{ metrica.etiqueta }}</dt>
            </div>
          </dl>
          <div class="mt-10 md:mt-14">
            <GobButton to="/problema" superficie="oscura" con-flecha>Conozca el reto territorial</GobButton>
          </div>
        </div>
      </div>

      <!-- Columna de la imagen: marco y acento son hermanos absolutos del mismo tamaño, así el corte
      diagonal ("/") de uno y el acento del otro comparten exactamente las mismas coordenadas. -->
      <div class="relative isolate min-h-80 bg-surface-deep lg:min-h-0">
        <div class="cerebro-imagen-marco absolute inset-0 overflow-hidden bg-surface-deep">
          <img ref="fondo" :src="imagen" alt="" class="cerebro-imagen absolute object-cover" width="1280" height="720" loading="lazy" decoding="async" />
        </div>
        <div class="cerebro-acento absolute inset-0" aria-hidden="true"></div>
      </div>
    </div>
  </section>
</template>

<script>
import GobButton from '@/components/GobButton.vue'
import imagen from '@/assets/home/parallax.png'
import patron from '@/assets/home/cerebro-digital-patron.svg'

/*
 * Cifras verificables, no resultados de impacto (aún no hay mediciones en clientes):
 */
const METRICAS = [
  {
    valor: '113.545',
    etiqueta: 'beneficiarios caracterizados con Gob 24/7.'
  },
  {
    valor: '9.000',
    etiqueta: 'personas atendidas por mes.'
  },
  {
    valor: '1.959',
    etiqueta: 'casos de vionlencia trazados en la subsecretaría de equidad de genero.'
  }
]

/** Fracción del desplazamiento de la sección que recorre la imagen. Con 20 % de sobrante no se ven bordes. */
const FACTOR_PARALLAX = 0.12

/**
 * HomeCerebroDigital
 * El parallax solo escucha el scroll mientras la sección está en pantalla, escribe el transform fuera de la
 * reactividad de Vue y no se activa con prefers-reduced-motion.
 */
export default {
  name: 'HomeCerebroDigital',
  components: { GobButton },
  data() {
    return { imagen, metricas: METRICAS, patron}
  },
  mounted() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    if (!('IntersectionObserver' in window)) return
    this.observador = new IntersectionObserver(([entrada]) => {
      if (entrada.isIntersecting) {
        window.addEventListener('scroll', this.programar, { passive: true })
        this.programar()
      } else {
        window.removeEventListener('scroll', this.programar)
      }
    })
    this.observador.observe(this.$refs.seccion)
  },
  beforeUnmount() {
    if (this.observador) this.observador.disconnect()
    window.removeEventListener('scroll', this.programar)
    cancelAnimationFrame(this.cuadro)
  },
  methods: {
    /** Agrupa los eventos de scroll en un solo cálculo por fotograma. */
    programar() {
      if (this.cuadro) return
      this.cuadro = requestAnimationFrame(this.actualizar)
    },
    actualizar() {
      this.cuadro = null
      const caja = this.$refs.seccion.getBoundingClientRect()
      const distanciaAlCentro = caja.top + caja.height / 2 - window.innerHeight / 2
      this.$refs.fondo.style.transform = `translate3d(0, ${Math.round(distanciaAlCentro * -FACTOR_PARALLAX)}px, 0)`
    }
  }
}
</script>

<style scoped>
/*
 * Mismo margen izquierdo que .gob-container (mx-auto + max-w-305 de 76.25rem + px-5 de 1.25rem),
 * calculado a mano porque este envoltorio vive fuera de .gob-container: así el titular arranca en
 * la misma columna que el resto de la página en vez de pegarse al borde del viewport.
 */
.cerebro-panel-contenido {
  padding-left: max(1.25rem, calc((100vw - 76.25rem) / 2 + 1.25rem));
}

@media (max-width: 1023px) {
  .cerebro-panel-contenido {
    padding-right: max(1.25rem, calc((100vw - 76.25rem) / 2 + 1.25rem));
  }
}

/* La imagen sobra un 20 % arriba y abajo para que el parallax no descubra bordes al hacer scroll. */
.cerebro-imagen {
  inset: -20% 0;
  width: 100%;
  height: 140%;
  will-change: transform;
}

.cerebro-acento {
  z-index: 1;
  pointer-events: none;
}

@media (min-width: 1024px) {
  /* El corte diagonal ("/"): del 12 % arriba al borde izquierdo abajo. Solo desde lg; en móvil la imagen
    queda rectangular, apilada bajo el panel de texto y sin el acento (que depende del mismo corte).*/
  .cerebro-imagen-marco {
    clip-path: polygon(12% 0%, 100% 0%, 100% 100%, 0% 100%);
  }

  .cerebro-acento {
    background: var(--color-electric);
    clip-path: polygon(12% 0%, 17.4% 0%, 5.4% 100%, 0% 100%);
    filter: drop-shadow(0 0 14px rgb(0 93 255 / 0.55));
  }
}

@media (prefers-reduced-motion: reduce) {
  .cerebro-acento {
    filter: none;
  }
}
</style>
